import { render, staticRenderFns } from "./chooseTask.vue?vue&type=template&id=81d8c3ec&scoped=true"
import script from "./chooseTask.vue?vue&type=script&lang=js"
export * from "./chooseTask.vue?vue&type=script&lang=js"
import style0 from "./chooseTask.vue?vue&type=style&index=0&id=81d8c3ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d8c3ec",
  null
  
)

export default component.exports